import DBUtil from './DBUtil'
import store from '@/store'
import { saveAs } from 'file-saver'
import trackEvent from './trackEvent'
import JSZip from 'jszip'
import { Message } from 'element-ui'
let zip = new JSZip()
let dayjs = require('dayjs')

const exportMemo = (
  tag,
  search,
  start_date,
  end_date,
  source,
  with_image,
  with_tag,
  with_link,
  contain_tag,
  last_year_today,
  deny_tag,
  app,
) => {
  console.log(
    'exportMemo 参数',
    'tag',
    tag,
    'search',
    search,
    'start_date',
    start_date,
    'end_date',
    end_date,
    'source',
    source,
    'with_image',
    with_image,
    'with_tag',
    with_tag,
    'with_link',
    with_link,
    'contain_tag',
    contain_tag,
    'last_year_today',
    last_year_today,
    'deny_tag',
    deny_tag,
  )
  return new Promise(async (resolve, reject) => {
    const { name, id } = store.state.me
    const start = new Date().getTime()
    // 导出的文件名
    const folderName = `flomo@${name}-${dayjs(new Date()).format('YYYYMMDD')}`

    const { zipCache } = await DBUtil.getZipCache()

    let memoHtml = ''
    // 已经缓存的memo slug
    const cacheSlug = localStorage.getItem('exportCacheSlug') ? JSON.parse(localStorage.getItem('exportCacheSlug')) : []

    let progress = localStorage.getItem('exportProgress') || 1

    if (zipCache && zipCache.length) {
      zipCache.forEach((item) => {
        if (item.path.indexOf('.txt') == 0) {
          zip.folder(folderName).file(item.path, item.file)
        }
        // 一张html
        if (item.path.indexOf('.txt') > -1) {
          memoHtml += item.file
        }
      })
    }

    const { memosGroupByMonth, total } = await DBUtil.getMemosByMonth(
      tag,
      search,
      start_date,
      end_date,
      source,
      with_image,
      with_tag,
      with_link,
      contain_tag,
      last_year_today,
      deny_tag,
    )

    store.commit('setExportTotal', total)
    localStorage.setItem('exportTotal', total)

    const dateOptions = []
    const tagOptions = []

    for (let monthMemo in memosGroupByMonth) {
      dateOptions.push(monthMemo)
      const month = monthMemo.replace('-', '')
      let memos = memosGroupByMonth[monthMemo].filter((memo) => {
        if (memo.tags && memo.tags.length) {
          memo.tags.forEach((tag) => {
            if (!tagOptions.includes(tag)) {
              tagOptions.push(tag)
            }
          })
        }
        return !cacheSlug.includes(memo.slug)
      })

      const filename = `${month}.html`
      const cancelExport = store.state.cancelExport

      // 判断 filename 是否存在，存在则跳过
      if (zip.file(`${folderName}/${filename}`) || zipCache.find((item) => item.path.indexOf(filename) > -1)) {
        console.log('跳过', filename)
        continue
      }

      // 计算 memo files size
      let size = 0
      memos.forEach((memo) => {
        if (memo.files && memo.files.length) {
          memo.files.forEach((file) => {
            size += file.size
          })
        }
      })

      // 2G
      if (size > 2048 * 1024 * 1024) {
        trackEvent('数据导出', '导出-失败', size)
        await DBUtil.deleteZipCache()
        localStorage.removeItem('exportProgress')
        localStorage.removeItem('exportTotal')
        localStorage.removeItem('exportCacheSlug')
        localStorage.removeItem('advancedSearchQuery')
        store.commit('setExportProgress', 0)
        store.commit('setExportTotal', 0)
        store.commit('setExportTime', 0)
        store.commit('setCancelExport', false)
        Message.error(app.$t('export.error'))
        resolve()
        return
      }

      if (!memos) {
        console.log(`${monthMemo} 没有数据`, memos, memosGroupByMonth)
      }

      const memosHtml = memos && memos.length ? memos.map((memo) => memoTemplate(memo)).join('') : ''

      memoHtml += memosHtml

      if (memos && memos.length) {
        await Promise.all(
          memos.map(async (memo) => {
            if (cancelExport) {
              resolve()
              return
            }

            // 检查图片地址是否过期
            const files = await DBUtil.checkImageUrl(memo.files)
            if (files.length) {
              memo.files &&
                memo.files.map((file) => {
                  const findFile = files.find((f) => f.id == file.id)
                  if (findFile.url) {
                    file.url = findFile.url
                  } else {
                    console.log('该文件没有 url ===>>> ', findFile)
                    file.url = ''
                  }
                })
            }

            await zipFiles(memo.files, folderName)
            await sleep(1000)

            cacheSlug.push(memo.slug)
            localStorage.setItem('exportCacheSlug', JSON.stringify(cacheSlug))
            progress++

            if (!cancelExport) {
              store.commit('setExportProgress', progress)
              localStorage.setItem('exportProgress', progress)
            }
          }),
        )
      }

      if (cancelExport) {
        resolve()
        return
      }
      // 一张html
      await DBUtil.saveZipCache(month, memosHtml, `${month}.txt`)
    }

    // tagOptions 按照字母顺序排序
    tagOptions.sort((a, b) => {
      return a.localeCompare(b, 'zh')
    })

    const end = new Date().getTime()
    const time = (end - start) / 1000
    store.commit('setExportTime', time)
    const date = dateFormat(new Date())
    const dateSelectOptions = renderSelectOptions(dateOptions)
    const tagSelectOptions = renderSelectOptions(tagOptions)
    const html = htmlTemplate(name, date, total, dateSelectOptions, tagSelectOptions, memoHtml)
    zip.folder(folderName).file('index.html', html)
    await generateSelectJsFile(folderName)
    zip.generateAsync({ type: 'blob' }).then(async (blob) => {
      // 获取zip size
      const size = blob.size / 1024 / 1024

      // 2G
      if (size > 2048) {
        trackEvent('数据导出', '导出-失败', size)
        await DBUtil.deleteZipCache()
        localStorage.removeItem('exportProgress')
        localStorage.removeItem('exportTotal')
        localStorage.removeItem('exportCacheSlug')
        localStorage.removeItem('advancedSearchQuery')
        store.commit('setExportProgress', 0)
        Message.error('导出文件过大，请缩小导出范围')
        reject('导出文件过大，请缩小导出范围')
        return
      }

      console.log('导出完成', time)

      saveAs(blob, `${folderName}.zip`)
      let action = '全量-下载'
      if (localStorage.getItem('advancedSearchQuery')) {
        action = '条件-下载'
      }

      trackEvent('数据导出', action, id, size)
      await DBUtil.deleteZipCache()
      localStorage.removeItem('exportProgress')
      localStorage.removeItem('exportTotal')
      localStorage.removeItem('exportCacheSlug')
      localStorage.removeItem('advancedSearchQuery')
      store.commit('setExportProgress', 0)
      resolve()
    })
  })
}

// 导出的html 模版
const htmlTemplate = (user, date, count, dateSelectOptions, tagSelectOptions, content) => {
  return `
        <html>
            <head>
                <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                <title>flomo · 浮墨笔记</title>
                <style type="text/css">
                  * {
                    margin: 0;
                    padding: 0;
                  }
                  body {
                    background: #fafafa;
                  }

                  header .logo {
                    text-align: center;
                    border-bottom: 1px solid #efefef;
                  }

                  header .top {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  }
                  header .logo,
                  header .top .user {
                    padding: 40px 0;
                  }
                  header .top .user .name {
                    color: #454545;
                    font-size: 16px;
                  }
                  header .top .user .date {
                    font-size: 12px;
                    color: #9d9d9d;
                  }

                  header .top .filter {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  }
                  header .top .filter button {
                    padding: 9px 10px;
                    background: #30cf79;
                    border-radius: 3px;
                    color: #fff;
                    font-size: 14px;
                    border: none;
                    cursor: pointer;
                  }
                  header,
                  .memos {
                    width: 600px;
                    margin: 0 auto;
                  }
                  .memos h1 {
                    margin-top: 30px;
                  }
                  .memo {
                    margin: 20px 0;
                    background: #fff;
                    padding: 20px;
                    border-radius: 6px;
                    word-wrap: break-word;
                  }
                  .memo:hover {
                    box-shadow: 0px 2px 10px #dddddd;
                  }
                  .memo .time {
                    color: #8d8d8d;
                    font-size: 12px;
                  }
                  .memo .content {
                    color: #323232;
                    font-size: 14px;
                  }
                  .memo .content p {
                    line-height: 1.8;
                    min-height: 20px;
                    margin: 0;
                  }
                  .memo .content ul,
                  .memo .content ol {
                    padding-inline-start: 22px;
                    margin: 0;
                  }
                  .memo .content li {
                    line-height: 1.8;
                  }
                  .memo .files img {
                    max-width: 100%;
                    border: 1px solid #e6e6e6;
                    border-radius: 4px;
                    margin: 6px 0;
                  }
                </style>
                <style>
                .custom-select {
                  position: relative;
                  font-size: 14px;
                  color: #9d9d9d;
                  background: #efefef;
                  border-radius: 3px;
                  border: none;
                  margin-right: 10px;
                }

                .custom-select select {
                  display: none;
                }

                .select-selected {
                  /* background-color: DodgerBlue; */
                  background: #efefef;
                  color: #9d9d9d;
                }

                .select-selected:after {
                  position: absolute;
                  content: "";
                  top: 14px;
                  right: 10px;
                  width: 0;
                  height: 0;
                  border: 6px solid transparent;
                  border-color: #7d7d7d transparent transparent transparent;
                }

                .select-selected.select-arrow-active:after {
                  border-color: transparent transparent #7d7d7d transparent;
                  top: 7px;
                }

                .select-items div,
                .select-selected {
                  color: rgba(157, 157, 157, 1);
                  padding: 9px 12px;
                  font-size: 14px;
                  color: #9d9d9d;
                  border: none;
                  cursor: pointer;
                  border-radius: 3px;
                  border: none;
                  width: 120px;
                  user-select: none;
                }

                .select-items {
                  position: absolute;
                  background-color: white;
                  top: 100%;
                  left: 0;
                  right: 0;
                  z-index: 99;
                  max-height: 200px;
                  overflow-y: auto;
                  overflow-x: hidden;
                  box-shadow: 0px 4px 2px #dddddd;
                }

                .select-items::-webkit-scrollbar {
                  width: 5px;
                }

                .select-items::-webkit-scrollbar-track {
                  background: #f1f1f1;
                }

                .select-items::-webkit-scrollbar-thumb {
                  background: #888;
                }

                .select-hide {
                  display: none;
                }

                .select-items div:hover,
                .same-as-selected {
                  background-color: rgba(0, 0, 0, 0.1);
                }
              </style>
            </head>
            <body>
              <header>
                <div class="logo">
                  <svg width="96" height="31" viewBox="0 0 96 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.87056 9.11086C4.87056 6.25522 5.89594 4.89539 7.81854 4.89539H12.5609V0H7.81854C2.69163 0 0 3.39957 0 9.11086V10.8786V14.9581V30.3242H4.87056V15.3661H12.5609V10.8786H4.87056V9.11086ZM79.5937 27.8765C81.3881 29.7803 83.6952 30.7321 86.3868 30.7321C89.0785 30.7321 91.2574 29.7803 93.18 27.8765C95.1026 25.9727 95.9998 23.525 95.9998 20.5334C95.9998 17.5418 94.9744 15.0941 93.18 13.1903C91.2574 11.2866 89.0785 10.3347 86.3868 10.3347C83.6952 10.3347 81.5163 11.2866 79.5937 13.1903C77.6711 15.0941 76.7739 17.5418 76.7739 20.5334C76.7739 23.525 77.7993 25.9727 79.5937 27.8765ZM81.6444 20.5334C81.6444 17.5418 83.6952 15.502 86.3868 15.502C89.0785 15.502 91.2574 17.5418 91.1292 20.5334C91.1292 23.661 89.0785 25.7008 86.3868 25.7008C83.6952 25.7008 81.6444 23.661 81.6444 20.5334ZM32.8147 30.7321C30.1231 30.7321 27.816 29.7802 26.0215 27.8765C24.2271 25.9727 23.2017 23.661 23.2017 20.6694C23.2017 17.6777 24.0989 15.23 26.0215 13.3263C27.9441 11.4225 30.1231 10.4706 32.8147 10.4706C35.5063 10.4706 37.6853 11.4225 39.6079 13.3263C41.5305 15.23 42.4277 17.6777 42.4277 20.6694C42.4277 23.661 41.5305 26.1087 39.6079 28.0124C37.6853 29.9162 35.5063 30.7321 32.8147 30.7321ZM32.8147 15.502C30.1231 15.502 28.0723 17.5418 28.0723 20.5334C28.0723 23.661 30.1231 25.7007 32.8147 25.7007C35.5063 25.7007 37.5571 23.661 37.5571 20.5334C37.5571 17.5418 35.5063 15.502 32.8147 15.502ZM62.0358 19.9894V30.4601H57.2934V19.7175C57.2934 17.1338 55.8835 15.502 53.9609 15.502C51.7819 15.502 50.1157 16.8618 50.1157 19.9894V30.4601H45.3733V10.8786H50.1157V13.7342C51.0129 11.5585 53.32 10.4706 55.3708 10.4706C58.3187 10.6066 60.2413 11.8305 61.2667 14.1422C62.5484 11.6945 64.471 10.4706 67.0345 10.4706C71.5205 10.4706 74.084 13.5982 74.084 19.3095V30.4601H69.3416V19.8535C69.3416 17.1338 67.9317 15.502 65.8809 15.502C63.5738 15.502 62.0358 17.1338 62.0358 19.9894ZM15.6366 4.89539V0H20.379V30.4602H15.6366V7.2071V4.89539Z" fill="#202020"/>
                  </svg>
                </div>
                <div class="top">
                  <div class="user">
                    <div class="name">@${user}</div>
                    <div class="date">于 ${date} 导出 ${count} 条 MEMO</div>
                  </div>
                  <div class="filter">
                    <div class='custom-select'>
                        <select name="date" id="date">
                          <option value="">选择年月</option>
                          ${dateSelectOptions}
                        </select>
                    </div>
                    <div class='custom-select'>
                      <select name="tag" id="tag">
                        <option value="">选择标签</option>
                        ${tagSelectOptions}
                      </select>
                    </div>
                    <button>筛选</button>
                  </div>
                </div>
              </header>
              <div class="memos">
                  ${content}
              </div>
              <script>
                const memos = document.querySelectorAll(".memo");
                const dateSelect = document.querySelector("#date");
                const tagSelect = document.querySelector("#tag");
                const filterBtn = document.querySelector("button");
                filterBtn.addEventListener("click", () => {
                  const date = dateSelect.value;
                  const tag = tagSelect.value;

                  memos.forEach((memo) => {
                    const time = memo.querySelector(".time").innerText;
                    const content = memo.querySelector(".content").innerText;
                    const isDateMatch = time.includes(date);
                    const isTagMatch = content.includes(tag);
                    if (isDateMatch && isTagMatch) {
                      memo.style.display = "block";
                    } else {
                      memo.style.display = "none";
                    }
                  });
                });
              </script>
              <script src='select.js'></script>

            </body>
        </html>
    `
}

// memo html 模版
const memoTemplate = (memo) => {
  const { created_at, content, files, slug } = memo
  const filesHtml =
    files && files.length
      ? files
          .map((file) => {
            // 判断file path 是否有后缀
            if (file.path.indexOf('.') > -1) {
              return `<img src="${file.path}" />`
            } else {
              return `<img src="${file.path}.jpg" />`
            }
          })
          .join('')
      : ''
  return `
        <div class="memo">
            <div class="time">${created_at}</div>
            <div class="content">${content}</div>
            <div class="files">${filesHtml}</div>
        </div>
    `
}

// files 打包
const zipFiles = (files, email) => {
  return new Promise(async (resolve, reject) => {
    // 降低并发数，避免浏览器崩溃,sleep 1000ms

    if (files && files.length) {
      files.forEach(async (file, index) => {
        let { url, path, id } = file

        // 判断 path 是否有后缀，没有则添加.jpg
        if (!path.includes('.')) {
          path = `${path}.jpg`
        }

        if (!zip.file(`${email}/${path}`)) {
          const newUrl = url.replace('flomo.oss-cn-shanghai.aliyuncs.com', 'static.flomoapp.com')
          const res = await fetch(newUrl)
          const blob = await res.blob()

          // 判断 fetch 是否成功
          if (blob.size) {
            await DBUtil.saveZipCache(id, blob, path)
          } else {
            console.log('下载图片失败', newUrl)
          }

          await sleep(1000)
          zip.folder(email).file(path, blob)
        } else {
          console.log('跳过', path)
        }

        if (index == files.length - 1) {
          resolve()
        }
      })
    } else {
      resolve()
    }

    // base64 打包 图片太大，不推荐
    // for (let file of files) {
    //   const { path, url } = file

    //   const fileData = await getBase64Image(url)
    //   zip.file(`${email}/${path}`, fileData.replace('data:image/png;base64,', ''), { base64: true })
    // }
    // resolve()
  })
}

const getBase64Image = (url) => {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.src = url.replace('flomo.oss-cn-shanghai.aliyuncs.com', 'static.flomoapp.com') // 绕开 service-worker 的 cache 机制，要确保 static.flomoapp.com 域名可用
    image.crossOrigin = 'Anonymous'
    image.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(image, 0, 0, image.width, image.height)
      const dataURL = canvas.toDataURL('image/png')
      resolve(dataURL)
    }
  })
}

const sleep = (time) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

// render select options
const renderSelectOptions = (options) => {
  return options.map((option) => `<option value="${option}">${option}</option>`).join('')
}

// date format
const dateFormat = (date) => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  return `${year}-${month}-${day}`
}

// generate select js file
const generateSelectJsFile = (email) => {
  return new Promise((resolve, reject) => {
    const jsContent = `
    var x, i, j, l, ll, selElmnt, a, b, c;
			x = document.getElementsByClassName("custom-select");
			l = x.length;
			for (i = 0; i < l; i++) {
				selElmnt = x[i].getElementsByTagName("select")[0];
				ll = selElmnt.length;
				a = document.createElement("DIV");
				a.setAttribute("class", "select-selected");
				a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
				x[i].appendChild(a);
				b = document.createElement("DIV");
				b.setAttribute("class", "select-items select-hide");
				for (j = 0; j < ll; j++) {
					c = document.createElement("DIV");
					c.innerHTML = selElmnt.options[j].innerHTML;
					c.addEventListener("click", function (e) {
						var y, i, k, s, h, sl, yl;
						s = this.parentNode.parentNode.getElementsByTagName("select")[0];
						sl = s.length;
						h = this.parentNode.previousSibling;
						for (i = 0; i < sl; i++) {
							if (s.options[i].innerHTML == this.innerHTML) {
								s.selectedIndex = i;
								h.innerHTML = this.innerHTML;
								y = this.parentNode.getElementsByClassName("same-as-selected");
								yl = y.length;
								for (k = 0; k < yl; k++) {
									y[k].removeAttribute("class");
								}
								this.setAttribute("class", "same-as-selected");
								break;
							}
						}
						h.click();
					});
					b.appendChild(c);
				}
				x[i].appendChild(b);
				a.addEventListener("click", function (e) {
					e.stopPropagation();
					closeAllSelect(this);
					this.nextSibling.classList.toggle("select-hide");
					this.classList.toggle("select-arrow-active");
				});
			}
			function closeAllSelect(elmnt) {
				var x,
					y,
					i,
					xl,
					yl,
					arrNo = [];
				x = document.getElementsByClassName("select-items");
				y = document.getElementsByClassName("select-selected");
				xl = x.length;
				yl = y.length;
				for (i = 0; i < yl; i++) {
					if (elmnt == y[i]) {
						arrNo.push(i);
					} else {
						y[i].classList.remove("select-arrow-active");
					}
				}
				for (i = 0; i < xl; i++) {
					if (arrNo.indexOf(i)) {
						x[i].classList.add("select-hide");
					}
				}
			}

			document.addEventListener("click", closeAllSelect);
      `
    const blob = new Blob([jsContent], { type: 'text/javascript' })
    zip.file(`${email}/select.js`, blob)
    resolve()
  })
}

export default exportMemo
